import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import ReactPlayer from "react-player/lazy";
import wellnessPracticeProgressStore from "../../store/wellnessPracticeProgressStore";
import WellnessProgressTracker from "../../components/WellnessProgressTracker";
import logger from "../../utils/logger";
import { useBootstrap } from "@/features/bootstrap";
import { useAudioPreference } from "../../hooks/useAudioPreference";
import { useAudioNavigation } from "@/hooks/useAudioNavigation";

const DEEP_BREATHE_DURATION_MS = 8000;

const DeepBreatheCopy = () => {
  const imgRef = useRef(null);
  const [playing] = useAudioPreference();
  const { data: user } = useBootstrap();
  const store = wellnessPracticeProgressStore;

  const audio_url_prefix = (user?.voice ?? "english female").replace(" ", "_");
  logger.log(audio_url_prefix);

  const audioHandlers = useAudioNavigation({
    to: "/howdoifeel",
    fallbackMs: DEEP_BREATHE_DURATION_MS,
    beforeNavigate: () => store.setLine("line1", 100),
  });

  useEffect(() => {
    const updateImageSrc = () => {
      if (imgRef.current) {
        const baseSrc = imgRef.current.src.replace(/\?.*$/, "");
        imgRef.current.src = `${baseSrc}?x=${Math.random()}`;
      }
    };

    updateImageSrc();

    store.setLine("line1", 0);
    store.setLineProgressAnimated("line1", DEEP_BREATHE_DURATION_MS);

    return () => {
      updateImageSrc();
    };
  }, [store]);

  return (
    <>
      <div className="sticky top-0 mt-10 sm:mt-0 z-10 shrink-0 bg-white sm:ml-[130px] px-0 sm:px-8 lg:px-32">
        <header className="px-4 py-4 text-center sm:px-6 sm:pb-4 sm:pt-12">
          <h1 className="mb-2 text-xl font-bold md:text-3xl">Take a deep breath</h1>
          <p className="mx-auto text-sm sm:text-base text-gray-600">Let's begin with a calming breath</p>
        </header>
        <WellnessProgressTracker />
      </div>
      <motion.div className="flex min-h-screen flex-1 flex-row bg-white">
        <div className="h-0 w-0 overflow-hidden opacity-0">
          <ReactPlayer
            playing={playing}
            url={"audio/" + audio_url_prefix + "/deepbreathe.wav"}
            muted={!playing}
            {...audioHandlers}
          />
        </div>
        <div className="flex w-full flex-col items-center md:ml-[130px]">
          <img
            ref={imgRef}
            className="mt-16 h-[48vh] md:h-[30vmax]"
            src="../images/GIF_FirstBreath_Crop copy.gif"
            alt="Loading..."
            loading="lazy"
          />
        </div>
      </motion.div>
    </>
  );
};

export default DeepBreatheCopy;
